import { mergeMessages } from 'ui/i18n/utils';
import { LoadedLocales } from 'ui/i18n/types';

export default function prepareLocales(locales: LoadedLocales) {
  return {
    en: mergeMessages(locales.common || {}, locales.en || {}, locales.autogenEn || {}),
    de: mergeMessages(locales.common || {}, locales.de || {}, locales.autogenDe || {}),
  };
}
